const DEFAULT_DOCUSIGN_BUNDLE_URL = 'https://js-d.docusign.com/bundle.js';

const waitForDocuSignApi = async (): Promise<void> => {
  for (let i = 0; i < 80; i++) {
    if (window.DocuSign?.loadDocuSign) {
      return;
    }
    await new Promise((r) => setTimeout(r, 50));
  }
  throw new Error('DocuSign JS API did not become available');
};

export const ensureDocuSignScriptLoaded = async (): Promise<void> => {
  if (window.DocuSign?.loadDocuSign) {
    return;
  }

  const existing = document.querySelector<HTMLScriptElement>(
    'script[src*="docusign"][src*="bundle.js"]',
  );
  if (existing) {
    await waitForDocuSignApi();
    return;
  }

  await new Promise<void>((resolve, reject) => {
    const s = document.createElement('script');
    s.src = process.env.REACT_APP_DOCUSIGN_BUNDLE_URL ?? DEFAULT_DOCUSIGN_BUNDLE_URL;
    s.async = true;
    s.onload = () => {
      void waitForDocuSignApi().then(resolve).catch(reject);
    };
    s.onerror = () => reject(new Error('Failed to load DocuSign bundle'));
    document.body.appendChild(s);
  });
};

export const getDocuSignIntegrationKey = (): string => {
  return process.env.REACT_APP_DOCUSIGN_INTEGRATION_KEY ?? '';
};
